import React, { Component } from 'react';
import {
  TextField,
  MenuItem,
  Paper,
  Popper,
  InputAdornment,
  IconButton,
  Tooltip,
  Grid,
  Typography,
} from '@material-ui/core';
import { Help as HelpIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import { defaultStyles } from '../util/styles';
import Autosuggest from 'react-autosuggest';
import { normalizeString } from '../util/helpers';
import schools from '../res/data/schools';
import clsx from 'clsx';

const styles = theme => ({
  ...defaultStyles(theme),
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

const maxSuggestions = 8;

function getSchoolIndex(value) {
  const lower = normalizeString(value.toLowerCase());
  // this is far from efficient, maybe i shouldn't do this on each change?
  for (let i = 0; i < schools.length; i++) {
    let school = schools[i];
    if (normalizeString(school.NAZIV.toLowerCase()) === lower) {
      return i;
    }
  }
  return null;
}

// TextField with school school name autocompletion.
class SchoolAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],

      inputValue: props.value,

      label: props.label,
      disabled: props.disabled,

      schoolIndex: getSchoolIndex(props.value),
    };
    this.anchorEl = null;
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  handleChange = (event, { newValue }) => {
    const index = getSchoolIndex(newValue);

    this.setState({ inputValue: newValue, schoolIndex: index });

    if (index !== null) {
      this.props.onChange({ target: { value: schools[index].NAZIV } });
    } else {
      this.props.onChange({ target: { value: newValue } });
    }
  };

  renderInputComponent = inputProps => {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;

    return (
      <TextField
        fullWidth
        InputProps={{
          inputRef: node => {
            ref(node);
            inputRef(node);
          },
          classes: {
            input: classes.input,
          },
          endAdornment:
            this.state.schoolIndex === null ? null : this.moreInfoTooltip(),
        }}
        className={clsx(classes, classes.customDisabledInput)}
        {...other}
      />
    );
  };

  moreInfoTooltip = () => {
    const school = schools[this.state.schoolIndex];
    return (
      <InputAdornment position='end'>
        <Tooltip
          title={
            <Grid container direction='column'>
              <Grid item>
                <Typography variant='body2'>{school.NAZIV}</Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>
                  {`${school.NASLOV} ${school['POŠTNA ŠTEVILKA']} ${
                    school['POŠTA']
                  }`}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>{school.EMAIL}</Typography>
              </Grid>
            </Grid>
          }>
          <IconButton>
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </InputAdornment>
    );
  };

  renderSuggestion = (school, { query, isHighlighted }) => {
    return (
      <MenuItem
        title={school.NAZIV}
        selected={isHighlighted}
        component='div'
        key={school.NAZIV}>
        {school.NAZIV}
      </MenuItem>
    );
  };

  getSuggestions = value => {
    const inputValue = normalizeString(value.trim().toLowerCase());
    const inputLength = inputValue.length;

    if (inputLength <= 3) return [];

    let result = [];

    // Highly inefficient searching "algortihm". Maybe it should have been done better
    for (let school of schools) {
      if (normalizeString(school.NAZIV.toLowerCase()).includes(inputValue)) {
        result.push(school);
        if (result.length >= maxSuggestions) break;
      }
    }

    return result;
  };

  getSuggestionValue = school => {
    return school.NAZIV;
  };

  render = () => {
    const { classes } = this.props;

    return (
      <Autosuggest
        renderInputComponent={this.renderInputComponent}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          classes,
          id: 'users-autosuggest-input',
          label: this.state.label,
          variant: 'outlined',
          value: this.state.inputValue,
          required: this.props.required,
          onChange: this.handleChange,
          inputRef: node => {
            this.anchorEl = node;
          },
          disabled: this.props.disabled,
        }}
        theme={{
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderSuggestionsContainer={options => (
          <Popper anchorEl={this.anchorEl} open={Boolean(options.children)} style={{
            zIndex: 1000,
          }}>
            <Paper
              {...options.containerProps}
              style={{
                width: this.anchorEl ? this.anchorEl.clientWidth : undefined,
              }}
              square>
              {options.children}
            </Paper>
          </Popper>
        )}
      />
    );
  };
}

export default withStyles(styles)(SchoolAutocomplete);